/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SeedOrphanage, SeedOrphanageInterface } from "../SeedOrphanage";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_seedContractAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Add",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "ClearRegister",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "Deliver",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "Register",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Remove",
    type: "event",
  },
  {
    inputs: [],
    name: "SEED_CONTRACT_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "addSeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "clearRegister",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "deliver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getRegister",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSeeds",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "isRegistered",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "removeSeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SeedOrphanageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SeedOrphanageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SeedOrphanage__factory extends ContractFactory {
  constructor(...args: SeedOrphanageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _seedContractAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SeedOrphanage> {
    return super.deploy(
      _seedContractAddress,
      overrides || {}
    ) as Promise<SeedOrphanage>;
  }
  getDeployTransaction(
    _seedContractAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_seedContractAddress, overrides || {});
  }
  attach(address: string): SeedOrphanage {
    return super.attach(address) as SeedOrphanage;
  }
  connect(signer: Signer): SeedOrphanage__factory {
    return super.connect(signer) as SeedOrphanage__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SeedOrphanageInterface {
    return new utils.Interface(_abi) as SeedOrphanageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SeedOrphanage {
    return new Contract(address, _abi, signerOrProvider) as SeedOrphanage;
  }
}
